var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDietScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H31V31H1V1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72395 10.4471C9.8067 10.6135 9.93432 10.7535 10.0924 10.8513C10.2505 10.949 10.4327 11.0007 10.6186 11.0004H21.3813C21.5672 11.0007 21.7494 10.949 21.9075 10.8513C22.0656 10.7535 22.1932 10.6135 22.276 10.4471L23.556 7.88972C23.6156 7.7694 23.6504 7.63831 23.6583 7.50425C23.6662 7.3702 23.6471 7.23592 23.6021 7.10941C23.557 6.9829 23.487 6.86674 23.3962 6.76784C23.3053 6.66894 23.1955 6.58932 23.0733 6.53372C20.8526 5.52591 18.442 5.00452 16.0033 5.00452C13.5646 5.00452 11.154 5.52591 8.93329 6.53372C8.81071 6.5893 8.70059 6.66903 8.60952 6.76812C8.51845 6.86722 8.44829 6.98366 8.40323 7.11049C8.35818 7.23731 8.33915 7.37192 8.34729 7.50627C8.35544 7.64061 8.39058 7.77193 8.45062 7.89239L9.72395 10.4471Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5C14 16.1187 12.4333 15 10.5 15C8.56667 15 7 16.1187 7 17.5V24.5C7 25.163 7.26339 25.7989 7.73223 26.2678C8.20107 26.7366 8.83696 27 9.5 27C10.163 27 10.7989 26.7366 11.2678 26.2678C11.7366 25.7989 12 25.163 12 24.5V24.052C12.0002 22.064 12.5996 20.1222 13.72 18.48V18.48C13.901 18.185 13.9978 17.8461 14 17.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.5C18 16.1187 19.5667 15 21.5 15C23.4333 15 25 16.1187 25 17.5V24.5C25 25.163 24.7366 25.7989 24.2678 26.2678C23.7989 26.7366 23.163 27 22.5 27C21.837 27 21.2011 26.7366 20.7322 26.2678C20.2634 25.7989 20 25.163 20 24.5V24.052C19.9998 22.064 19.4004 20.1222 18.28 18.48V18.48C18.099 18.185 18.0022 17.8461 18 17.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.27173V6.99973",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.27173V6.99973",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietScale);
export default __webpack_public_path__ + "static/media/DietScale.3f1c2191572af706df4aea95f8e2e8bc.svg";
export { ForwardRef as ReactComponent };